import api from "./api";

export function getForexExchangePage(country_id) {
  return api.get(`/forexexchange/${country_id}`);
}

export function createForexExchangePage(data) {
  return api.post("/forexexchange", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateForexExchangePage(country_id, data) {
  return api.put(`/forexexchange/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
